import flatMap from 'lodash/flatMap';

import store from "./../../store";
import * as types from "../../actions/actionTypes";
import LayoutCommon from "./layoutCommon";
import {SQFT_FEATURES} from "../sqft/constants";
import {getSlabsFeatureGroup} from "../../misc/helpers";
import {setActivePreset} from "../../actions/actionFunctions";
// import {getBvGroupFeatures} from "../../api/server-api";

export default class LayoutCommonNew extends LayoutCommon {

  isNewLayout = true;

  // /**
  //  * Returns feature
  //  * @param neededId {number}
  //  * @param withOtherGroups {boolean}
  //  * @returns feature {object}
  //  */
  // getFeatureById(neededId, withOtherGroups = false) {
  //   let allFeatures = this.getAllFeatures(withOtherGroups);
  //   for (let i = 0; i < allFeatures.length; i++) {
  //     if (allFeatures[i].dbFeature.id === neededId) {
  //       return allFeatures[i];
  //     }
  //   }
  //   return null
  // }

  // /**
  //  * Returns feature
  //  * @param skuNumber {string}
  //  * @param featureGroupPartId {string}
  //  * @returns feature {object}
  //  */
  // getFeatureBySku(skuNumber, featureGroupPartId= "") {
  //   if (featureGroupPartId) {
  //     const featureGroupFound = this.getFeatureGroupByPartId(featureGroupPartId);
  //     if (featureGroupFound) {
  //       for (let i = 0; i < featureGroupFound.features.length; i++) {
  //         if (featureGroupFound.features[i].dbFeature.sku === skuNumber) {
  //           return featureGroupFound.features[i];
  //         }
  //       }
  //     }
  //   }
  //   let allFeatures = this.getAllFeatures();
  //   for (let i = 0; i < allFeatures.length; i++) {
  //     if (allFeatures[i].dbFeature.sku === skuNumber) {
  //       return allFeatures[i];
  //     }
  //   }
  //   return null
  // }

  /**
   * @param partId {string}
   * @param compressedFeature {object}
   * @param featuresToLoad {Array} // only if layout is changed - we need to load features to changed feature group
   * @return featureLoaded {featureInterface}
   */
  getFeatureFromAllLayouts = (partId, compressedFeature, featuresToLoad) => {
    const {dbFeatureId} = compressedFeature;
    const parentItems = this.getFeatures(true);
    let childSubPart = null;
    let featureLoaded = null;
    parentItems.forEach(parentGroup => {
      if (childSubPart) {
        return
      }
      if (partId === SQFT_FEATURES.slabs) {
        childSubPart = getSlabsFeatureGroup(this)
      } else if (parentGroup) {
        childSubPart = parentGroup.subParts().find(subPart => subPart.part.partId === partId);
      }
      if (childSubPart && childSubPart.part.features) {
        featureLoaded = childSubPart.part.getFeatureById(dbFeatureId, true);
        if (!featureLoaded) { // if feature isn't found in the current layout, let's find it in another layouts
          let allFeatures = [];
          Object.keys(this.layoutNames).forEach((layoutType) => {
            if (layoutType !== "All") {
              allFeatures = [...allFeatures, ...childSubPart.part.featuresList[layoutType]]
            }
          });
          featureLoaded = allFeatures.find((feature) => feature.dbFeature.id === dbFeatureId);
          if (!featureLoaded
            && (document.kvConfig.visualizerType === "Kitchen" || document.kvConfig.visualizerType === "kvScene")
            && this.qtCategories.some(qtCat => qtCat.qtCategoryHasBeenChanged)
            && featuresToLoad.length
          ) {
            // console.info("Cart feature is not loaded, trying in change categories:", dbFeatureId);
            this.qtCategories.forEach(qtCat => {
              const changedSubPart = qtCat.subParts.find(subPart => subPart.part.partId === partId);
              if (changedSubPart) {
                // console.info("Cart feature is not loaded, found subpart:", cartItem);
                const needToLoadFeature = featuresToLoad.find(dbFeature => dbFeature.id === dbFeatureId);
                if (needToLoadFeature) {
                  changedSubPart.part.setGroupFeatures([needToLoadFeature], 0, false)
                }
                featureLoaded = childSubPart.part.features.find((feature) => feature.dbFeature.id === dbFeatureId);
                // if (featureLoaded) {
                // console.info("Cart feature is not loaded, it's ok, we found it:", dbFeatureId, featureLoaded);
                // }
              }
            })
          }
          if (!featureLoaded) {
            if ((partId === "slabs") && compressedFeature && compressedFeature.partId) {
              const featureGroup = this.getFeatureGroupByPartId(compressedFeature.partId);
              if (featureGroup) {
                featureLoaded = featureGroup.getFeatureById(dbFeatureId, true);
              }
            }
          }
          if (!featureLoaded) {
            console.error("Cart feature is not loaded:", partId, dbFeatureId);
          }
        }
        // console.log('featureLoaded', featureLoaded);
      }
    });
    return featureLoaded
  }


  /**
   *
   * @param bvState {object}
   * @param isCartAndUserStatedUpdateNeeded {boolean}
   * @param useNames {boolean}
   * @param needToChangeLayout {boolean}
   * @param firstLoad {boolean}
   * @param isFake {boolean}
   */
  setActiveFeaturesFromObject(
    bvState,
    isCartAndUserStatedUpdateNeeded = false,
    useNames = false,
    needToChangeLayout = true,
    firstLoad = false,
    isFake = false
  ) {
    if (bvState) {

      const layout_type = +bvState.layout_type;
      needToChangeLayout = needToChangeLayout && (layout_type || layout_type === 0) && (layout_type !== +this.type);

      if (needToChangeLayout) {
        this.type = layout_type;
      }
      this.scene = bvState.scene || this.scene;

      console.log("bvState===>", bvState);
      console.log("bvState firstLoad", firstLoad);
      // to avoid checks below
      bvState.disabled_parts = bvState.disabled_parts || [];

      this.getFeatures()
        .forEach((parentGroup) => {
          let relatedItems = parentGroup.getRelatedItems();
          relatedItems.forEach((subPart) => {
            const partId = subPart.partId;
            let previouslySelectedItem = null;
            subPart.selectedFeaturesHistory.some(featureName => {
              previouslySelectedItem = subPart.getFeatureByPartName(featureName);
              return previouslySelectedItem
            });
            if (bvState.hasOwnProperty(partId) || previouslySelectedItem) {
              if (!bvState.disabled_parts.includes(partId)) {
                subPart.disabled = false
              }
              if (useNames) {
                const matchingFeature = (partId === "backsplash" && bvState["backsplash_type"])
                  ? subPart.getFeatureByBacksplashType(bvState["backsplash_type"], bvState["backsplash"])
                  : subPart.getFeatureByPartName(bvState[partId]);
                if (matchingFeature) {
                  subPart.activeFeature = matchingFeature;
                } else if (previouslySelectedItem) {
                  subPart.activeFeature = previouslySelectedItem;
                }
              } else {
                subPart.activeFeature = subPart.getFeatureById(bvState[partId], true) || parentGroup.getDefaultFeature();
              }
              if (subPart.layerPositions && subPart.activeFeature) {
                // subPart.setLayerPositions(); // enabled // we have to set vanity on its layerPosition, grohe vanities have different sku so can not be found in the code below
                Object.keys(subPart.layerPositions).forEach(position => {
                  const partIdPosition = partId + "_" + position;
                  if (bvState.disabled_parts.includes(partIdPosition)) {
                    subPart.layerPositions[position] = null;
                  } else if (bvState[partIdPosition]) {
                    subPart.layerPositions[position] = useNames
                      ? subPart.getMatchingPositionFeature(position, subPart.activeFeature, isFake ? this : null)
                      : subPart.getFeatureById(bvState[partIdPosition], true)
                  } else if (!((position !== "C" && subPart.activeFeature.metaData.layerPosition === "C") || (subPart.activeFeature.metaData.layerPosition !== "C" && position === "C"))) {
                    subPart.layerPositions[position] = subPart.getMatchingPositionFeature(position, subPart.activeFeature, isFake ? this : null)
                  }
                })
              // } else if (subPart.hasAdditionalParts && (subPart.activeFeatureParts == null || !subPart.activeFeatureParts.length)) {
              //   subPart.activeFeatureParts = subPart.setActiveFeatureParts();
              }
              subPart.placeholderChanged = !!subPart.activeFeature;
              // const {activeQuoteIndex} = store.getState().quotesState;
              // subPart.firstClick = !!subPart.activeFeature;
              // if (subPart.firstClick) {
              //   console.log("subPart.firstClick", subPart);
              // }
            }
            if (bvState.disabled_parts.includes(partId)) {
              subPart.disabled = true
            }
            if (!subPart.activeFeature) {
              // we might have features uploaded only for one room layout as in case of replacement tub on american_standard_master
              subPart.setDefault()
            }
            if (!subPart.disabled && subPart.layerPositions && Object.values(subPart.layerPositions).every(feature => !feature)) {
              subPart.setLayerPositions(); // mirror cases
            }
            if (subPart.activeFeature) {
              if (!subPart.activeFeature.notAvailableInVisualizer) {
                subPart.activeFeature.dbFeature.unlocked = true;
              }
              if (subPart.layerPositions) {
                Object.keys(subPart.layerPositions).forEach(position => {
                  if (subPart.layerPositions[position]) {
                    subPart.layerPositions[position].dbFeature.unlocked = true;
                  }
                })
              }
              if (subPart.hasAdditionalParts && subPart.activeFeatureParts && subPart.activeFeatureParts.length) {
                subPart.activeFeatureParts.forEach(additionalFeature => {
                  additionalFeature.dbFeature.unlocked = true;
                })
              }
            }
          })
        });

      if (needToChangeLayout) {
        this.changeLayout(this.getFeatures());
      }

      if (isCartAndUserStatedUpdateNeeded) {
        this.setCartStateAndUserStateFromBvState(bvState);
      }

      const layoutParts = this.designNavigationItems()
        .filter(parentGroup => parentGroup.part.categoryEnabled)
        .map((parentGroup) => parentGroup.part.partName);

      if (!this.isFakeLayout) {
        store.dispatch({
          type: types.SET_LAYOUT_DATA_PARTS,
          payload: {layoutParts}
        });
      }

      store.dispatch({
        type: types.UPDATE_CANVAS_COUNT
      });

      if (bvState.id) {
        store.dispatch(setActivePreset(bvState.id));
      }

    }
  }

  fixFeatureMetaData(dbFeature) {
    // if (Array.isArray(dbFeature.metaData.CropCoords) && !dbFeature.metaData.CropCoords[1] && dbFeature.metaData.CropCoords[0]) {
    //   dbFeature.metaData.CropCoords = dbFeature.metaData.CropCoords[0].split(","); // ['0, 460, 1060, 574'] -> ['0', ' 460', ' 1060', ' 574']
    // }
    if (!Array.isArray(dbFeature.metaData.RoomLayout) || !dbFeature.metaData.RoomLayout.length) {
      dbFeature.metaData.RoomLayout = ["Layout1"];
    } else {
      // console.log("dbFeature.metaData.RoomLayout", dbFeature.metaData.RoomLayout);
      dbFeature.metaData.RoomLayout = dbFeature.metaData.RoomLayout.map((mValue) => {
        if (typeof mValue !== "string" || !mValue.includes("Layout")) {
          mValue = "Layout" + mValue
        }
        return mValue
      })
    }
    Object.keys(dbFeature.metaData).forEach(key => {
      if (Array.isArray(dbFeature.metaData[key])) {
        dbFeature.metaData[key] = flatMap(dbFeature.metaData[key], (metaValue => {
          if (metaValue.includes(", ")) {
            return metaValue.split(", ")
          } else if (metaValue.includes(",")) {
            return metaValue.split(",")
          }
          return metaValue
        }));
        if (key === "SortPosition") {
          dbFeature.metaData["SortPositionNum"] = +(dbFeature.metaData[key][0])
        }
      }
    });
    return dbFeature
  }

}

